import defaultCover from "@/../image/default-dashboard-cover.png";
import { assetUrl } from "@/config";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Chip,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import path from "path";
import { useNavigate, useOutletContext } from "react-router-dom";

const DashboardItem = (props) => {
    const { imageUrl, title, subtitle, category, handleClick, disabled = false, restProps } = props;

    return (
        <Card sx={{ display: "flex", minHeight: 120 }}>
            <CardMedia
                component="img"
                image={imageUrl}
                sx={{
                    height: "100%",
                    width: 120,
                    minWidth: 120,
                    maxWidth: 200,
                }}
                alt="Dashboard"
            />
            <Divider orientation="vertical" variant="middle" flexItem sx={{ marginX: 1 }} />
            <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h5">{title}</Typography>
                    <Typography variant="body1" color="text.secondary">
                        {subtitle}
                    </Typography>
                    <Stack direction="row" spacing={0.5} sx={{ marginTop: 1 }}>
                        {category?.map((tag, index) => <Chip key={index} label={tag} size="small" />)}
                    </Stack>
                </Box>
            </CardContent>
            <CardActions>
                <Button variant="outlined" endIcon={<OpenInNewIcon />} size="small" onClick={handleClick}>
                    view
                </Button>
            </CardActions>
        </Card>
    );
};

export default function DashboardHub(props) {
    const { dashboards } = useOutletContext();
    const navigate = useNavigate();

    return (
        <Stack spacing={1}>
            {dashboards?.map((dashboard) => (
                <DashboardItem
                    key={dashboard.id}
                    title={dashboard.title}
                    subtitle={dashboard.description}
                    category={[]}
                    imageUrl={path.join(assetUrl, defaultCover)}
                    handleClick={() => navigate(`/dashboard-hub/view/${dashboard.id}`)}
                />
            ))}
        </Stack>
    );
}
